import axios from 'axios';
import resolve  from '../resolver.js';
import checkJwt from '../../Global/jwtChecker' 
import logout from '../../Global/logout'
import momentum from 'moment'

export default async function CreateExchangeRate(
    data
) {
    const unHashedJwt = await checkJwt()
 
    if(!unHashedJwt){
        logout()
    }

    return await resolve(
        axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/currency' , {
            method: 'POST',
            headers: { 'Authorization' : unHashedJwt},
            data: {
                "date_of_exchange_rate": momentum(data.date_of_exchange).format('YYYY-MM-DD'),
                "currency_name": data.currency_name.trim(),
                "currency_short": data.automatic ? data.automaticPicked.Form.Label : data.currency_short.trim(),
                "exchange_rate": data.exchange_rate,
                "automatic": data.automatic
            }      
        }).then(
            res => (res)
        ).catch(error => error.response.data)
    )
}